import React from 'react';
import imgMen from '../../img/FNShop.png'


// Muestra el intro de la web con un mensaje de la tienda y una informacion sobre las mascotas
const BannerIntro = ({greeting}) => {
    return (
        <>
        <div className="contenedor">
            <div className="login">
                <h2 className="mensaje">{greeting}</h2>
                <img src={imgMen} alt="perro_de_compra"/>
            </div>
        </div>
        <div className="container sec-1 py-md-5">
            <h3 className="title-estilo mb-lg-5 mb-4">HAGA FELIZ A SU MASCOTA!</h3>
            <div className="row">
                <div className="col-md-4 img1 content-gd">
                    <img src="../asset/ab1.jpg" className="img-fluid" alt="perro_acostado" />
                </div>
                <div className="col-md-4 content-gd- ab-content py-lg-5 my-lg-5">
                    <h4>¿Sabias que los perros no sudan como los humanos?</h4>
                    <p className="parrInfo"> Los perros expulsan el sudor solo por las almohadillas de sus patas y su lengua, por eso cuando llevas a tu perro a caminar no sientes su pelaje húmedo, pero si puedes percibir que jadea constantemente, este es el mecanismo para regular su temperatura corporal y transpirar.</p>

                </div>
                <div className="col-md-4 img2 content-gd">
                    <img src="../asset/ab2.jpeg" className="img-fluid" alt="perro_acostado" />
                </div>
            </div>
        </div>
        </>
    )
}
export default BannerIntro;